import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";

/**
 * @type {{name: string, timestamp: number}}
 */
const metadata = {
  name: "remove-empty-volume-discount",
  timestamp: new Date("2024-05-25").getTime(),
};

/**
 * Remove empty volume discounts that was created by mistake
 * @param {Object} args
 * @param {Object} args.settings
 * @param {string} args.settings.namespace
 */
async function migrate({ settings }) {
  const volumeDiscountRepository = new VolumeDiscountRepository(settings);
  const volumeDiscounts = await volumeDiscountRepository.getAll();

  if (volumeDiscounts.items.length <= 0) {
    return;
  }

  if (volumeDiscounts.items.length >= 200) {
    console.log(
      `migrate:Volume Discounts collection is too large to migrate`,
      metadata.name
    );
    return;
  }

  for (const volumeDiscount of volumeDiscounts.items) {
    const conditions = [
      volumeDiscount.title == undefined,
      volumeDiscount.isEnabled == undefined,
      volumeDiscount.applyTo == undefined,
      volumeDiscount.offers == undefined,
      volumeDiscount.startTimestamp == undefined,
    ];

    console.log("Checking volume discount", metadata.name, volumeDiscount);

    if (conditions.some((condition) => condition)) {
      console.log(
        "Removing empty volume discount",
        metadata.name,
        volumeDiscount._id
      );
      await volumeDiscountRepository.delete(volumeDiscount._id);
    }
  }
}

export default { metadata, migrate };
